module.exports = __webpack_public_path__ + "media/icons/white-reports-349fb28a.png";